import { FilterObjectType } from '../context/filterContext'

export const getPaginationQueryVariables = (
  routeFilters: FilterObjectType,
  searchString: string,
  defaultPageSize = 100,
  queryServerSide = false
) => {
  const { pagination, sort } = routeFilters

  return {
    pagination: {
      limit: (pagination && pagination?.pageSize) ?? defaultPageSize,
      ...(queryServerSide && pagination && pagination?.current
        ? {
            offset: Math.floor((pagination.current - 1) * pagination.pageSize),
          }
        : {}),
    },
    ...(queryServerSide
      ? {
          ...(sort && sort.field
            ? {
                sort: {
                  [sort.field as string]:
                    sort.order === 'ascend' ? 'asc' : 'desc',
                },
              }
            : {}),
          ...(searchString ? { searchString: searchString } : {}),
        }
      : {}),
  }
}
